/* esm.sh - applesauce-relay@5.2.0/dist/operators/reverse-switch-map */
export * from "/*applesauce-relay@5.2.0/esnext/dist/operators/reverse-switch-map.mjs";
